<template lang="pug">
.scroll
  md-input-container
      aiq-input
      md-button.save-button(@click="save()") Save
  aiq-chip(v-for="item in filteredList",
          :key="item.id",
          :closable="true"
          :disabled="item.isSelected",
          @click="select(item)",
          class="large"
          :class="[color,item.isSelected ? 'selected' : '']") {{ item.name }}

  md-button.create-button(v-if="filteredList.length === 0") Create "{{ search }}"
</template>

<script>
export default {
  name: 'aiq-tag-list',
  props: {
    slected: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
    },
  },
  data() {
    return {
      search: '',
      selectedClone: [...(this.selected || [])],
    };
  },
  computed: {
    filteredList() {
      return (
        this.list.filter(e => e.name.indexOf(this.search) >= 0).map(e => {
          e.isSelected = this.isSelected(e);
          return e;
        }) || []
      );
    },
  },
  methods: {
    save() {
      this.$emit('save', this.selectedClone);
    },

    create() {
      this.$emit('create', this.search);
      this.search = '';
    },

    select(item) {
      if (item.isSelected) {
        this.selectedClone = this.selectedClone.filter(e => e.id !== item.id);
      } else {
        this.selectedClone.push(item);
      }
    },

    isSelected(item) {
      return !!this.selectedClone.find(e => e.id === item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll {
  height: calc(100vh - 110px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &:hover {
    &::-webkit-scrollbar-track {
      background-color: rgba(85, 85, 85, 0.1);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: transparent;
  }
}

.md-input-container {
  min-height: 36px;
  padding: 5px;
  margin: 0;
  button {
    margin: 0 0 0 5px;
  }
  &:after {
    display: none;
  }
}

.md-chip {
  min-height: 32px;
  height: auto;
  margin: 5px;
  cursor: pointer;
  white-space: normal;
  word-break: break-all;

  &:focus {
    color: rgba(0, 0, 0, 0.87);
    background-color: rgba(0, 0, 0, 0.12);
  }

  &.selected {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.12);

    &.tangerine {
      color: #fff;
      background-color: #a05af1;
    }
    &.kingdom {
      color: #fff;
      background-color: #e65bb3;
    }
    &.sunset {
      color: #fff;
      background-color: #e65bb3;
    }
  }
}

.create-button {
  padding: 9px 15px;
  margin: 0 5px;
  line-height: 18px;
  word-break: break-all;
  white-space: normal;
}

.testinput {
  height: 36px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  background-color: #e6f2fa;

  &::-webkit-input-placeholder {
    color: #6a7682;
    font-size: 14px;
  }
  &::-moz-placeholder {
    color: #6a7682;
    font-size: 14px;
    opacity: 1;
  }
  &:-moz-placeholder {
    color: #6a7682;
    font-size: 14px;
    opacity: 1;
  }
  &:-ms-input-placeholder {
    color: #6a7682;
    font-size: 14px;
  }
}
</style>
